import { useAppDispatch, useTypedSelector } from 'Store'
import { All_TARIFFS_COUNT_PER_REQUEST } from 'Util/constants'
import { useEffect } from 'react'
import { fetchAllTariffs } from '../tariffSlice'

function useTariffs() {
  const dispatch = useAppDispatch()
  const { allTariffs, allTariffsLoading, total_results } = useTypedSelector(state => state.tariff)

  useEffect(() => {
    dispatch(fetchAllTariffs({ bypass_pagination: true, count: All_TARIFFS_COUNT_PER_REQUEST }))
  }, [])

  return {
    allTariffs,
    allTariffsLoading,
    total_results
  }
}

export default useTariffs
